import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button, Grid } from '@mui/material'
import http from 'axios'

import { withStyles } from '@mui/styles'
import { style } from 'styles'
import { formatNumber } from 'core/lib'

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
	return new URLSearchParams(useLocation().search)
}

function ProductsSearch({ classes }) {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const { categoriesArray, products } = useSelector(state => state.products)
	const searchText = useQuery().get('s')
	const shop = useSelector(state => state.shop)
	const isCatalogue = Number(shop.profiles.ueby_catalogue_only)

	useEffect(() => {
		const loadProducts = async() => {
			const products = await http.post(`${window.__endpoint}/api/products/search`, {
				s: searchText,
			})
			dispatch({ type: 'loadProducts@products', products: products })
		}

		// Se cambia la categoria selezionata o al completamento del load delle categorie eseguo il caricamento dei prodotti
		dispatch({ type: 'loadProducts@products', products: null })
		loadProducts()
	}, [searchText, categoriesArray])

	const gotoProduct = (product) => {
		navigate(`/shop/prod/${product.url_name}-${product.item_id}`)
	}

	return (<div className={classes.page}>
		{categoriesArray.length > 0 && <div>
			<h3 className={classes.pageTitle}>Ricerca</h3>
			{products && <Grid container spacing={3} className={classes.productsList}>
				{products.length == 0 && <Grid item xs={12}>
					<p className={classes.pageSubTitle}>La ricerca di {searchText} non ha dato nessun risultato</p>
				</Grid>}
				{products.map((product, p) => (<Grid key={p} item xs={12}>
					<div className="product" onClick={() => gotoProduct(product)}>
						<div className="pic">
							<img  src={`${window.__endpoint}/images/products/m/${product.main_image ? product.main_image.image_id : 'missing'}.jpg`} alt={product.name} />
						</div>
						{product.html_title && product.html_title != '' && <div className="title" dangerouslySetInnerHTML={{
							__html: product.html_title
						}}></div>}
						<div className="description">{product.description}</div>
						<div className="price">
							{formatNumber(product.price)} €
						</div>
					</div>
				</Grid>))}
			</Grid>}
		</div>}
	</div>)
}

export default withStyles(style)(ProductsSearch)
